import { Grid } from "@mui/material";
import React from "react";
import PatientTable from "./home/table";
import PatientHeader from "./home/header";

const Patient = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PatientHeader />
      </Grid>
      <Grid item xs={12}>
        <PatientTable />
      </Grid>
    </Grid>
  );
};

export default Patient;
